<template>
  <div class="container-fluid navigation-bar p-1 px-2">
    <button @click="toggle" class="burger">
      <font-awesome-icon icon="fa-solid fa-bars"/>
    </button>

    <div class="navbar-logo"></div>
    <div class="navigation-box"></div>

    <div class="user-settings">
      <button @click="tawkTo" class="burger mx-3">
        <font-awesome-icon icon="fa-solid fa-question-circle"/>
      </button>

      <button @click="syncData" class="burger">
        <font-awesome-icon icon="fa-solid fa-arrows-rotate"/>
      </button>
    </div>
  </div>
</template>

<script>


export default {
  name: "NavigationBar",
  props: {
    toggle: {
      type: Function,
      require: true
    },
  },
  computed : {
    saleLines(){
      return this.$store.getters.getSaleLines;
    },
  },
  methods: {
    syncData() {
      if (this.saleLines.length > 0) {
        return Swal.fire({
          icon : `warning`,
          title : `Are you sure ?`,
          text : `This will clear all changes made to the order`,
          reverseButtons : true,
          confirmButtonColor : `red`,
          cancelButtonColor : `green`,
          showCloseButton : true,
          showCancelButton : true,
          showLoaderOnConfirm : true,
          preConfirm:()=> {
            let isAllowed = this.$store.dispatch(`validateSecurityPermission`,`Void`)
            if (!isAllowed) return ;
            return Promise.all(this.saleLines.map(line=>{
              line.VoidQty = line.Qty;
              return this.$store.dispatch(`logItemVoid`,line)
            })).then(()=>window.location.reload(true))
          }
        })
      }
      this.$utils.showLoading();
      return window.location.reload(true);
    },
    tawkTo() {
      return window.open('https://tawk.to/LytSupport', '_self');
    }
  }
}
</script>

<style lang="scss" scoped>
.burger {
  width: 40px;
  height: 40px;
  background: transparent;
  color: white;
  font-size: 30px;
}

.user-settings {
  display: flex;
  flex-direction: row;
  justify-content: end;
}
</style>
